import * as React from 'react';
import { Link } from 'react-router-dom';
import { Icon } from 'components/antd';
import classNames from 'classnames';

import styles from './LogoutButton.module.scss';

export interface LogoutButtonProps {
	to: string;
	text: string;
	alightRight?: boolean;
	className?: string;
}

export const LogoutButton: React.SFC<LogoutButtonProps> = props => {
	const { text, to, alightRight, className } = props;
	return (
		<div
			className={classNames(styles.logoutButtonWrapper, {
				[styles.logoutButtonWrapperRight]: alightRight,
			})}
		>
			<Link to={to} className={classNames(styles.logoutButton, className)}>
				<Icon size="xl" type="logout" />
				{text}
			</Link>
		</div>
	);
};

export default LogoutButton;
